import { render, staticRenderFns } from "./CurrencyAmount.vue?vue&type=template&id=3626c9a6&scoped=true"
import script from "./CurrencyAmount.vue?vue&type=script&lang=ts"
export * from "./CurrencyAmount.vue?vue&type=script&lang=ts"
import style0 from "./CurrencyAmount.vue?vue&type=style&index=0&id=3626c9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3626c9a6",
  null
  
)

export default component.exports